import React from "react";
import EditableInput from "./EditableInput";

const ObjectEditor = ({
  entry,
  objectFields,
  onAddField,
  onRemoveField,
  onChangeField,
}) => (
  <div className="space-y-3 rounded-2xl border border-slate-800/90 bg-slate-950/40 p-4">
    <div className="flex items-center justify-between gap-3">
      <p className="text-xs text-slate-400">Edit one field per row.</p>
      <button
        type="button"
        onClick={onAddField}
        className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white"
        aria-label={`Add ${entry.label} field`}
      >
        Add field
      </button>
    </div>

    {objectFields.length ? (
      objectFields.map((field, index) => (
        <div
          key={`${entry.key}-field-${index}`}
          className="rounded-2xl border border-slate-800 bg-slate-900/60 p-3"
        >
          <div className="mb-3 flex items-center justify-between gap-3">
            <span className="text-xs font-medium uppercase tracking-[0.12em] text-slate-500">
              Field {index + 1}
            </span>
            <button
              type="button"
              onClick={() => onRemoveField(index)}
              className="rounded-lg border border-rose-500/30 bg-rose-500/10 px-2.5 py-1.5 text-[11px] font-semibold text-rose-100 transition-colors hover:border-rose-400 hover:text-white"
              aria-label={`Remove ${entry.label} field ${index + 1}`}
            >
              Remove
            </button>
          </div>

          <div className="space-y-3">
            <EditableInput
              value={field.keyName ?? ""}
              onChange={(event) => onChangeField(index, "keyName", event.target.value)}
              ariaLabel={`${entry.label} field ${index + 1} key`}
              placeholder="Field name"
            />
            <EditableInput
              value={field.textValue ?? ""}
              onChange={(event) => onChangeField(index, "textValue", event.target.value)}
              multiline={field.mode === "json"}
              rows={field.mode === "json" ? 6 : 3}
              ariaLabel={`${entry.label} field ${index + 1} value`}
              placeholder={field.mode === "json" ? "Enter valid JSON for this value" : "Field value"}
            />
          </div>
        </div>
      ))
    ) : (
      <div className="rounded-2xl border border-dashed border-slate-700 px-4 py-4 text-sm text-slate-400">
        No fields yet. Add one to start editing this object.
      </div>
    )}
  </div>
);

export default ObjectEditor;
